<template>
<v-list
    class="account-nav bg-transparent"
    :model-value="modelValue"
    :density="isMobile ? 'comfortable' : 'compact'"
    :nav="!inMenu"
    @update:model-value="emit('update:modelValue', $event)"
>
    <template
        v-if="currentNav"
        v-for="(value, key) in currentNav"
        :key="key"
    >
        <AccountNavGroup
            :group="value"
            :id-prefix="`${key}`"
        ></AccountNavGroup>
    </template>
</v-list>
</template>

<script lang="ts" setup>
    import AccountNavGroup from '~/components/account/account-nav/AccountNavGroup/AccountNavGroup.vue';
    import {
        useIsMobile,
        AccountMenu
    } from '~/composables';
    import type {
        AccountNav,
        MembershipChoice
    } from '~/types';

    withDefaults(
        defineProps<{
            modelValue?: Nilish<string>;
            currentMembershipChoice: Nullable<MembershipChoice>;
            inMenu?: boolean;
        }>(),
        {
            inMenu: false
        }
    );

    const emit = defineEmits<{
        'update:modelValue': [value: string];
    }>();

    const { isMobile } = useIsMobile();
    const accountMenu = AccountMenu();
    const currentNav = useState<Nullable<AccountNav>>('keyCurrentAccountNav', () => null);

    await callOnce('keyAccountNavCallOnce', () => {
        setCurrentNav();
    }, { mode: 'render' });

    async function setCurrentNav(): Promise<void> {
        if (accountMenu.value) {
            currentNav.value = accountMenu.value;
        }
    }

    onUpdated(() => {
        setCurrentNav();
    });
</script>

<style lang="scss">
.account-nav {
    .v-list-item__spacer {
        width: 0.8rem !important;
    }
}
</style>
